import { Link } from 'react-router-dom';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';

type DataTableEditButtonProps = {
  editUrl?: string;
  onEdit?: () => void;
};

export function DataTableEditButton({ editUrl, onEdit }: DataTableEditButtonProps) {
  if (editUrl && onEdit) {
    throw new Error('Cannot have `editUrl` and `onEdit` on the same `DataTableEditButton`');
  }

  if (editUrl) {
    return (
      <Button title="Edit" variant="outline" size="sm" asChild>
        <Link to={editUrl}>
          <Icon icon="pencil" />
        </Link>
      </Button>
    );
  }

  if (onEdit) {
    return (
      <Button title="Edit" variant="outline" size="sm" onClick={onEdit}>
        <Icon icon="pencil" />
      </Button>
    );
  }

  return null;
}
